import { shouldEnableTracking } from './tracking.js';

let sentryModule;
const loadSentry = async () => {
  if (sentryModule) return sentryModule;
  sentryModule = await import('@sentry/react');
  return sentryModule;
};

// Initialise GlitchTip (compatible Sentry) uniquement si un DSN est fourni
export async function initErrorTracking() {
  if (!shouldEnableTracking()) return;

  const dsn = import.meta.env.VITE_GLITCHTIP_DSN;
  if (!dsn) return;

  const environment =
    import.meta.env.VITE_APP_ENV ||
    import.meta.env.MODE ||
    (import.meta.env.PROD ? 'production' : 'development');

  const release =
    import.meta.env.VITE_RELEASE ||
    import.meta.env.VITE_COMMIT_SHA ||
    (typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : undefined);

  const Sentry = await loadSentry();
  Sentry.init({
    dsn,
    environment,
    release,
    tracesSampleRate: 0.05, // Biais léger pour les traces perf
    attachStacktrace: true,
  });
}
